import React from "react";
import Questions, { Question } from "./Questions";
import { IDynamicBlockComponent } from "../../dynamicPageBuilder/IDynamicBlockComponent";
import { get, orderBy } from "lodash";

export type FaqQuestion = {
  background: string;
  faq: string;
};

type FaqProps = {
  data: Array<FaqQuestion>;
  questions: {
    faq: Array<Question>;
    names: string;
  };
};

const Faq: React.FunctionComponent<IDynamicBlockComponent> = ({
  blockData,
}): React.ReactElement => {
  const { data, questions } = blockData as FaqProps;
  const faq = get(questions, "faq", []);
  const names = get(questions, "names", "");
  const [faqData] = data;
  const { background } = faqData;
  const faqSorted = orderBy(faq, ["orderPosition"]);

  return (
    <div
      className={`paddingsForBlocks ${
        background === "grey" ? "mainBackgroundGrey" : ""
      }`}
    >
      <Questions questions={faqSorted} header={names} />
    </div>
  );
};

export default Faq;
